import {createAction} from "@reduxjs/toolkit";
import {
  DriverActivityFilterFormValues
} from "../../../components/form/DriverActivityFilterForm/DriverActivityFilterForm";
import {GridState} from "@ag-grid-community/core";
import {TransportSearchCriteria} from "@ots-frontend/ots-data";

export const setDriverActivityPageCriteria = createAction<TransportSearchCriteria>("ots-ui/driver-activity-page/setCriteria");
export const setDriverActivityPageFilter = createAction<DriverActivityFilterFormValues>("ots-ui/driver-activity-page/setFilter");
export const setDriverActivityPageState = createAction<GridState>("ots-ui/driver-activity-page/setState");
export const toggleDriverActivityPagePerson = createAction<string>("ots-ui/driver-activity-page/togglePerson");
export const clearToggleDriverActivityPagePerson = createAction<void>("ots-ui/driver-activity-page/clearTogglePerson");
